import { render } from "./MonglishFooter.vue?vue&type=template&id=1cbedcb7&scoped=true"
import script from "./MonglishFooter.vue?vue&type=script&lang=js"
export * from "./MonglishFooter.vue?vue&type=script&lang=js"

import "./MonglishFooter.vue?vue&type=style&index=0&id=1cbedcb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbedcb7"]])

export default __exports__